module.exports = {
    bindings: {
        chapter: '<',
        numberOfEcicsItems: '<',
        onClickChapter: '&'
    },
    controller: chapterController,
    templateUrl: 'nomenclature/components/nomenclature-chapter.html'
};

chapterController.$inject = [
    'language',
    'applicationStateService'
];

function chapterController(
    language,
    state
) {
    var vm = {
        showAtrButton: language.get() === 'en',
        state: state,
    };
    return vm;
}